import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from '../api/client';

export type TimingPoint = {
  id: number;
  eventId: number;
  timingPointName: string;
};

export const timingPointService = {
  list: (eventId: number) =>
    apiRequest<{ timingPoints: TimingPoint[] }>(
      withParams(API_ENDPOINTS.timingPointList, { eventId })
    ).then((res) => res.timingPoints),

  create: (eventId: number, body: Omit<TimingPoint, 'id'>) =>
    apiRequest<TimingPoint>(withParams(API_ENDPOINTS.timingPointCreate, { eventId }), { body }),

  update: (eventId: number, timingPointId: number, body: Partial<Omit<TimingPoint, 'id'>>) =>
    apiRequest<TimingPoint>(
      withParams(API_ENDPOINTS.timingPointUpdate, { eventId, timingPointId }),
      { body }
    ),

  delete: (eventId: number, timingPointId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.timingPointDelete, { eventId, timingPointId })),
};
